import { IGeneralContext } from '@picsart/miniapps-sdk/types';
import { DAILY_ALLOWANCE } from '../constants';

export default function allowanceReached({ internals }: IGeneralContext) {
  if (DAILY_ALLOWANCE === 0) return false;
  return (internals.getState().limit?.remaining ?? 1) <= 0;
}
